export default __webpack_public_path__ + "static/media/samskrithigoshala - hero - phone1.5x_450.10bb1ddb.jpg";